import { Component, OnInit, Input, EventEmitter, Output } from "@angular/core";
import { GuiGuard } from "../../../../../../shared/guard/base-gui-guard";
import { Router } from "@angular/router";

@Component({
  selector: "pi",
  templateUrl: "./pi.component.html",
})
export class PiComponent implements OnInit {
  @Input() table_id: string;
  @Input() data;
  @Input() order;
  @Input() orderby;
  @Output() out: EventEmitter<any>;
  @Output() sortby: EventEmitter<any>;

  public identity;
  public searchText = "";

  constructor(public gui: GuiGuard, private _router: Router) {
    this.identity = JSON.parse(localStorage.getItem("identity"));
    this.out = new EventEmitter();
    this.sortby = new EventEmitter();
  }

  ngOnInit() {
    // console.log(this.table_id);
    // console.log(this.data);
  }

  saveEmit(accion, id, item = null) {
    let send;
    send = {
      evento: accion,
      id: id,
      item: item,
    };
    this.out.emit(send);
  }

  sort(by) {
    if (by === this.orderby) {
      if (this.order === "DESC") {
        this.order = "ASC";
      } else {
        this.order = "DESC";
      }
    } else {
      this.orderby = by;
      this.order = "DESC";
    }

    let order = {
      sort: this.order,
      sortby: this.orderby,
    };

    this.sortby.emit(order);
  }

  sorting(by) {
    return this.orderby != by
      ? "fa-sort"
      : this.order == "DESC"
      ? "fa-sort-desc"
      : "fa-sort-asc";
  }

  testingPriorityLevel(tpl) {
    switch (tpl) {
      case "LOWPRIORITY":
        return "Low";
      case "MEDIUMPRIORITY":
        return "Medium";
      case "FASTPRIORITY":
        return "Fast";
      case "URGENTPRIORITY":
        return "Urgent Same Day";
      default:
        return tpl;
    }
  }

  showmanifest(e) {
    let manifest = e.manifestPriorityLevel;
    if (manifest == "LOWPRIORITY") manifest = "Low Priority - 30 Days";
    else if (manifest == "NOMANIFEST") manifest = "No Manifest";
    else if (manifest == "URGENTPRIORITY") manifest = "Urgent Same Day - 1 Day";
    else if (manifest == "MEDIUMPRIORITY")
      manifest = "Medium Priority - 15 Days";
    else if (manifest == "FASTPRIORITY") manifest = "Fast Priority - 7 Days";
    return manifest;
  }

  paidStatus(e) {
    let status = "Paid";
    if (e.isPaid == 0 || e.isPaid == null) status = "Pending";

    if (e.netTerms == "SORTANDSETTLE" && (e.isPaid == 0 || e.isPaid == null))
      status = "S&S";
    else if (
      e.netTerms == "REVENUESHARE" &&
      (e.isPaid == 0 || e.isPaid == null)
    )
      status = "RS";
    return status;
  }

  status(e) {
    let status = "";
    if (e.numReceived > 0 || e.numReceivedSecond > 0) {
      status = "Received";
    }
    if (e.numInmanifest > 0 || e.numInmanifestSecond > 0) {
      status = status + (status != "" ? "/" : "") + "In Manifest";
    }
    if (e.numIntesting > 0 || e.numIntestingSecond > 0) {
      status = status + (status != "" ? "/" : "") + "In Testing";
    }
    if (e.numInsales > 0 || e.numInsalesSecond > 0) {
      status = status + (status != "" ? "/" : "") + "In Sales";
    }
    if (e.numProcessed > 0 || e.numProcessedSecond > 0) {
      status = status + (status != "" ? "/" : "") + "Processed";
    }

    if (status == "") {
      status = e.status;
    }
    if (status == "INTRANSIT") {
      status = "In Transit";
    } else if (status == "INTESTING") {
      status = "In Testing";
    } else if (status == "PROCESSED") {
      status = "Processed";
    } else if (status == "RECEIVED") {
      status = "Received";
    } else if (status == "PICKEDUP") {
      status = "Picked up";
    }

    return status;
  }

  hasContainer(pi) {
    if (
      pi.numInmanifest !== 0 ||
      pi.numInmanifestFour !== 0 ||
      pi.numInmanifestSecond !== 0 ||
      pi.numInmanifestThird !== 0 ||
      pi.numInsales !== 0 ||
      pi.numInsalesFour !== 0 ||
      pi.numInsalesSecond !== 0 ||
      pi.numInsalesThird !== 0 ||
      pi.numIntesting !== 0 ||
      pi.numIntestingFour !== 0 ||
      pi.numIntestingSecond !== 0 ||
      pi.numIntestingThird !== 0 ||
      pi.numReceived !== 0 ||
      pi.numReceivedFour !== 0 ||
      pi.numReceivedSecond !== 0 ||
      pi.numReceivedThird !== 0
    ) {
      return true;
    }

    return false;
  }

  goContainer(po) {
    // this._router.navigate(['container-inventory/filter', po]);
    window.open("/container-inventory/filter/" + po);
  }
}
